import api from './api'; 

export const authService = {
  
  // 1. Étape 1 : Email/Password
  async login(email, password) {
    try {
      const response = await api.post('/auth/login', { email, password });
      return response.data; // Retourne { status: "success", message: "OTP_SENT" }
    } catch (error) {
      throw error.response?.data?.error || 'Identifiants invalides ou compte verrouillé';
    }
  },

  // 2. Étape 2 : Vérification du code reçu par mail
  async verifyOtp(email, otp) {
    try {
      const response = await api.post('/auth/verify-otp', { email, otp });
      
      // Le backend renvoie : { token, role, mustChangePassword }
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('role', response.data.role); // "ADMIN" ou "SUPER_ADMIN"
        localStorage.setItem('userEmail', email);
      }
      
      return response.data; // On retourne tout l'objet pour gérer la redirection
    } catch (error) {
      throw error.response?.data?.error || 'Code OTP invalide ou expiré';
    }
  },

  // 3. Récupérer les infos de l'admin connecté
  async getCurrentUser() {
    try {
      const response = await api.get('/auth/me');
      return response.data;
    } catch (error) {
      // Si erreur (token expiré), on déconnecte
      if (error.response?.status === 401) {
        this.logout();
      }
      throw error;
    }
  },

  // 4. Déconnexion propre
  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('userEmail');
    window.location.href = '/login';
  },

  // 5. Réinitialisation de mot de passe (via token)
  async completePasswordReset(data) {
    try {
      const response = await api.post('/auth/reset-password', data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.error || 'Une erreur est survenue lors de la réinitialisation';
    }
  },

  // --- HELPERS ---
  getRole() {
    return localStorage.getItem('role');
  },

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }
};